import React, { useContext } from "react";
import ReactDOM from "react-dom";
import LanguageContext from "../helper/LanguageContext";
import MaterialIcon from "./MaterialIcon";

/**
 * Small "bald verfügbar" teaser for products that are listed in the sidebar
 * but not launched yet (Josch.IO, ProjektView, Kostenprognose.IO, Terminplan.IO).
 */
export default function ProductTeaserModal({ product, onClose }) {
  const { strings } = useContext(LanguageContext);
  if (!product) return null;
  const note = product.note || null;
  const subtitle = !note && product.subtitleKey ? strings[product.subtitleKey] : null;
  const description = strings[`products_${product.id}_teaser`];
  return ReactDOM.createPortal(
    <div className="product-teaser-overlay" role="dialog" aria-modal="true">
      <div className="product-teaser-backdrop" onClick={onClose} />
      <div className="product-teaser-dialog">
        <button type="button" className="kj-btn kj-btn--icon kj-btn--neutral product-teaser-close" onClick={onClose} aria-label={strings.close || "Schließen"}>
          <MaterialIcon icon="close" size={20} color="currentColor" />
        </button>
        <div className="product-teaser-icon">
          <MaterialIcon icon={product.icon || "rocket_launch"} size={30} color="var(--kjuup-accent)" weight={400} />
        </div>
        {note ? null : (
          <div className="product-teaser-eyebrow">{strings.products_coming_soon || "Bald verfügbar"}</div>
        )}
        <h2 className="product-teaser-title">{product.label}</h2>
        {subtitle ? <div className="product-teaser-subtitle">{subtitle}</div> : null}
        <p className="product-teaser-text">
          {note ||
            description ||
            strings.products_teaser_generic ||
            "Dieses Produkt wird gerade entwickelt und erscheint hier, sobald es verfügbar ist. Es ist dann direkt aus deinem Kjuup-Konto nutzbar."}
        </p>
        <button type="button" className="kj-btn kj-btn--primary" onClick={onClose}>
          {strings.ok || "OK"}
        </button>
      </div>
    </div>,
    document.body
  );
}
